import { useSelector } from "react-redux";

import {
    selectCrmToExportContacts,
    selectExportFlowPhase,
    selectIsFetchingExportPreview,
} from "../../../store/selectors";
import ContactsExportPreviewModal from "./ContactsExportPreviewModal";
import { LoadingModal } from "./LoadingModal/LoadingModal";

export type ExportContactsToCrmContainerProps = {
    onConfirmExport: () => void;
    onCancelPreview: () => void;
    onCancelLoading: () => void;
};

const ExportContactsToCrmContainer = (props: ExportContactsToCrmContainerProps) => {
    const { onConfirmExport, onCancelPreview, onCancelLoading } = props;
    const isFetchingPreviews = useSelector(selectIsFetchingExportPreview);
    const integrationName = useSelector(selectCrmToExportContacts);
    const phase = useSelector(selectExportFlowPhase);

    const isPreviewVisible = phase.type === "previewingCrmContacts";
    const isLoadingVisible = phase.type === "matchingCrmContacts" || isFetchingPreviews;

    return (
        <>
            <ContactsExportPreviewModal
                isOpen={isPreviewVisible}
                integrationName={integrationName}
                onExport={onConfirmExport}
                onCancel={onCancelPreview}
            />
            <LoadingModal
                isOpen={isLoadingVisible}
                onClose={onCancelLoading}
            />
        </>
    );
};

export default ExportContactsToCrmContainer;
